<script lang="ts" setup>
const props = defineProps<{
  items: Array<unknown>
  class?: string
  strategy?: 'absolute' | 'fixed'
}>()
</script>

<template>
  <ClientOnly>
    <template #fallback>
      <slot name="header" />
    </template>
    <UDropdown
      :ui="{
        base: 'dropdown-body',
        rounded: 'rounded-sm',
        container: `dropdown-wrapper z-40 min-w-60 w-full max-w-[95vw] ${props.class ?? ''} ${
          props.strategy === 'fixed' ? 'w-auto' : 'w-full'
        }`,
        divide: 'divide-y-0',
        padding: 'p-0',
        item: {
          base: 'dropdown-item',
          rounded: 'rounded-none',
          padding: 'p-0',
        },
        wrapper: 'w-full',
      }"
      :items="items"
      :popper="{ placement: 'bottom-start', arrow: true, strategy: props.strategy ?? 'absolute' }">
      <div class="text-text2 dark:text-dmText2 outline-none bg-transparent flex gap-2 w-full">
        <slot name="header" />
      </div>

      <template #item="{ item, index }">
        <slot name="dropdown-item" :item="item" :index="index" />
      </template>
    </UDropdown>
  </ClientOnly>
</template>

<style lang="postcss" scoped>
:deep(.dropdown-item) {
  @apply text-left;

  > div {
    @apply flex w-full h-full px-3 py-3;
  }
}

:deep(.dropdown-body) {
  @apply !rounded-sm;
}

:deep(.active) {
  @apply font-bold bg-neutral7 dark:bg-dmGray5;
}
</style>
